import styled from 'styled-components';

export const EntityHierarchy = styled.span`
  margin-right: 7px;
`;
